import {
  EventPayloadType,
  type EventFilter,
} from "@package/ui-gql/index-analytics";
import { type WritableDraft } from "immer";
import { sortBy, uniq } from "lodash";
import { useMemo, useState } from "react";
import { EVENT_TYPE_TO_DISPLAY } from "../../constants/constants";
import { useItemGridFilterContext } from "../ItemGridFilter/context-item-grid-filter";
import {
  ItemGridFilterDataList,
  type FilterValueEntry,
} from "../ItemGridFilter/ItemGridFilterDataList";

type SupportedFilter = EventFilter | null | undefined;

export function ItemGridFilterEventType() {
  const [query, setQuery] = useState<string>("");

  const { filter, updateFilterState } = useItemGridFilterContext();

  const filterWithEventType: SupportedFilter = filter;
  const items = useMemo<FilterValueEntry[]>(() => {
    const values: FilterValueEntry[] =
      Object.values(EventPayloadType)
        .map((type) => {
          const id = type;
          const name = EVENT_TYPE_TO_DISPLAY[type];
          const checked = filterWithEventType?.eventType?.includes(id) ?? false;
          return {
            id,
            name,
            checked,
          };
        })
        .filter((entry) =>
          entry.name.toLowerCase().includes(query.toLowerCase()),
        ) ?? [];

    return sortBy(values, (entry) => entry.name);
  }, [filterWithEventType?.eventType, query]);

  return (
    <ItemGridFilterDataList
      items={items}
      property="eventType"
      text="Event Type"
      onQueryValueChanged={setQuery}
      onRequestFilterReset={() =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            delete draft.eventType;
          }
        })
      }
      onRequestFilterUpdate={(id, include) =>
        updateFilterState((draft: WritableDraft<SupportedFilter>) => {
          if (draft) {
            if (include) {
              draft.eventType = uniq([
                ...(draft.eventType ?? []),
                id as EventPayloadType,
              ]);
            } else if (draft.eventType?.length) {
              draft.eventType = draft.eventType.filter((type) => type !== id);
            }

            if (!draft.eventType?.length) {
              delete draft.eventType;
            }
          }
        })
      }
      onSelectAllChanged={(checked) => {
        if (checked) {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              draft.eventType = Object.values(EventPayloadType);
            }
          });
        } else {
          updateFilterState((draft: WritableDraft<SupportedFilter>) => {
            if (draft) {
              delete draft.eventType;
            }
          });
        }
      }}
    />
  );
}
